function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import __ from 'ramda/src/__';
import { MetadataCodeLoadedSelector, MetadataCodeTypeDictionarySelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { NA } from '../../../../reducers/constants/billing.payments.constants';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import CustomerLocaleKeys from '../../../../locales/keys';
import { ENTITLEMENT_CONTEXT_TYPES, ENTITLEMENT_SHARE_STATUS, SERVICE_ENTITLEMENTS_ACTIVATION_STATUS } from '../../../../customercare.constants';
var EntitlementThumbnailController = /*#__PURE__*/function () {
  function EntitlementThumbnailController(uiNotificationService, $ngRedux) {
    _classCallCheck(this, EntitlementThumbnailController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys,
      ENTITLEMENT_CONTEXT_TYPES: ENTITLEMENT_CONTEXT_TYPES,
      ENTITLEMENT_SHARE_STATUS: ENTITLEMENT_SHARE_STATUS,
      NA: NA,
      SERVICE_ENTITLEMENTS_ACTIVATION_STATUS: SERVICE_ENTITLEMENTS_ACTIVATION_STATUS,
      uiNotificationService: uiNotificationService,
      unitOfMeasure: undefined
    });
  }
  return _createClass(EntitlementThumbnailController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.EntitlementRecurringPeriodType];
      this.entitlementTooltip = require('../../../../components/shared/tooltipTemplates/entitlement.tooltip.html');
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          entitlementPeriodTypes: MetadataCodeTypeDictionarySelector(CODES.EntitlementRecurringPeriodType, store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      codeTables.forEach(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          _this.actions.fetchCodeTypes(codeType).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      });
      this.setActivationEntitlementStatus();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.entitlement) {
        this.setActivationEntitlementStatus();
      }
    }
  }, {
    key: "setActivationEntitlementStatus",
    value: function setActivationEntitlementStatus() {
      this.isEntitlementFirstUse = this.entitlement.ActivationStatus === SERVICE_ENTITLEMENTS_ACTIVATION_STATUS.AWAITING_ENTITLEMENT_FIRST_USE;
      this.isEntitlementFirstUseWithPricingPlan = this.entitlement.ActivationStatus === SERVICE_ENTITLEMENTS_ACTIVATION_STATUS.AWAITING_ENTITLEMENT_FIRST_USE_WITH_PRICING_PLAN;
    }
  }, {
    key: "canShareEntitlement",
    value: function canShareEntitlement() {
      return !!this.entitlement.EntitlementIdentifier.EntitlementId && !this.entitlement.EntitlementIdentifier.RefundEntitlementConfigurationId && this.entitlement.EntitlementContextTypeCode === this.ENTITLEMENT_CONTEXT_TYPES.ACCOUNT;
    }
  }]);
}();
export default {
  bindings: {
    currencyCode: '<?',
    entitlement: '<',
    isSharedUsageTab: '<?',
    serviceIdentifier: '<?',
    onShareActionClicked: '&?',
    showTotalUsed: '<?'
  },
  controller: EntitlementThumbnailController,
  template: require('./entitlement.thumbnail.template.html')
};